export default "__VITE_ASSET__BwbRJii1__"